import styled from 'styled-components';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//////////////////////////////////////////////////

const StyledDatePicker = styled(DatePicker)`
  & .MuiOutlinedInput-root {
    border: none;
    border-radius: 0;
    max-width: 130px;
    color: ${({ theme }) => theme.colors.linkColor};

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.87);
    }

    &:hover:not(.Mui-disabled) {
      background-color: ${({ theme }) => theme.colors.bgColor};
    }
  }

  &.MuiTextField-root {
    min-width: 140px !important;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.87);
  }

  & .MuiInputBase-root {
    font-size: 12px;
    background-color: ${({ theme }) => theme.colors.white};
  }

  & .MuiInputBase-input {
    padding: 9px 3px 7px;
  }

  & .MuiInputLabel-root {
    transition: none;
    transform: translate(14px, 2px) scale(0.8);
    color: ${({ theme }) => theme.colors.linkColor};
  }

  & .MuiFormLabel-root {
    &.Mui-focused {
      color: ${({ theme }) => theme.colors.linkColor};
    }
  }

  .Mui-disabled {
    opacity: 0.7;
    color: ${({ theme }) => theme.colors.linkColor};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.linkColor};
  }

  & .MuiSvgIcon-root {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.darkGreen};
  }
`;

export {
  StyledDatePicker,
};
